module.exports = __webpack_public_path__ + "static/media/су.00874d53.mp3";